import { Api } from './Api'

class SiteState {
  get (siteId) {
    return fetch(Api.getBaseUrl() + 'sitestate/' + siteId, Api.getOptions())
  }
}

export default SiteState
